import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_103: FaireProductEntity = {
  token: "starter_collection_103",
  type: "product",
  name: "Billie Cheese Set",
  brandName: "Be Home",
  imageUrl:
    '"https://cdn.faire.com/fastly/34a0178119b488073355fc0cd88f67308ff38b5407c4f8e2017c3bb65abbbdf8.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=2887',
  priceDollars: 45,
  msrpDollars: 90,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
